module.exports = __webpack_public_path__ + "static/media/sharecard-slide-error.4644a069.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sharecard-slide-error.png
// module id = 2128
// module chunks = 6